type MoneyFormattingOptions = {
  hideEuroSign?: boolean;
  showDecimals?: boolean;
};

const formatMoney = (
  amount: number,
  attributes?: MoneyFormattingOptions
): string => {
  const { hideEuroSign, showDecimals = true } = attributes ?? {};

  let formattedAmount: string;
  const split = amount.toFixed(2).split(".");
  split[0] = split[0].replace("-", "");
  if (split[1] == "00") {
    formattedAmount = `${split[0]}`;
    if (!showDecimals) formattedAmount += ",-";
    else formattedAmount += ",00";
  } else {
    formattedAmount = split.join(",");
  }
  const absolutePrice = hideEuroSign ? formattedAmount : `€ ${formattedAmount}`;
  return amount < 0 ? `-${absolutePrice}` : absolutePrice;
};

export { formatMoney };
